import FriendlyError from '@/shared/utils/FriendlyError';

export const ErrorFallback = ({
	error,
	resetErrorBoundary,
}: {
	error: Error;
	resetErrorBoundary: () => void;
}) => {
	return (
		<div className="welcome">
			<div>
				<h2>Something went wrong</h2>
				{error instanceof FriendlyError ? <p>{error.message}</p> : null}
			</div>
			<button onClick={resetErrorBoundary}>Try again</button>
		</div>
	);
};
